import React from 'react';
import {
  HeroSection,
  StatsSection,
  AboutSection,
  PlatformsSection,
  GamesSection,
  TeamSection,
  PartnersSection,
  ContactSection,
  NewsletterSection,
} from '../components/sections';

const HomePage = () => {
  return (
    <>
      <HeroSection />
      <StatsSection />
      <AboutSection />
      <PlatformsSection />
      <GamesSection />
      <TeamSection />
      <PartnersSection />
      <ContactSection />
      <NewsletterSection />
    </>
  );
};

export default HomePage;
